
import { Component, Vue } from 'nuxt-property-decorator'
import type { MetaInfo } from 'vue-meta'
import QuizForm from '~/components/pages/quiz/QuizForm'
import { OnMounted, WithHead } from '~/core/vue.types'
import { useSEOMetaComposer } from '~/composables/seo.composable'

@Component({
  components: {
    QuizForm,
  },
  layout: 'no-footer',
})
export default class QuizPage extends Vue implements WithHead, OnMounted {
  head (): MetaInfo {
    return useSEOMetaComposer(
      this,
      {
        title: this.$t('head.meta.quiz.title').toString(),
        description: this.$t('head.meta.quiz.description').toString(),
        route: { name: 'quiz' },
        isNoIndex: true,
      },
    )
  }

  mounted () {
    this.$analytics.GTM.sendPageViewEvent({
      routeName: this.$route.name as string,
      pageTitle: this.$metaInfo.title || '',
      fullPath: this.$route.fullPath,
      fromPath: this.$nuxt.context.from ? this.$nuxt.context.from.fullPath : '',
      contentGroup: 'Quiz',
    })
  }
}
